import '../css/portfolio.css';
import '../css/background.css';
import Navbar from '../components/Navbar.jsx';
import Grid from '@material-ui/core/Grid';
import Footer from '../components/Footer.jsx';
import Dialog from '@material-ui/core/Dialog';
import { useEffect, useState } from 'react';

import pic1 from '../images/pic1.jpg';
import pic2 from '../images/pic2.jpg';
import pic3 from '../images/pic3.jpg';
import pic4 from '../images/pic4.jpg';
import pic5 from '../images/pic5.jpg';
import pic6 from '../images/pic6.jpg';
import pic7 from '../images/pic7.jpg';
import pic8 from '../images/pic8.jpg';
import pic9 from '../images/pic9.jpg';
import pic10 from '../images/pic10.jpg';
import pic11_after from '../images/pic11-after.jpg';
import pic12 from '../images/pic12.jpg';
import pic13 from '../images/pic13.jpg';
import pic14 from '../images/pic14.jpg';
import pic15 from '../images/pic15.jpg';
import pic16 from '../images/pic16.jpg';
import pic17 from '../images/pic17.jpg';
import pic18 from '../images/pic18.jpg';
import pic19 from '../images/pic19.jpg';
import pic20 from '../images/pic20.jpg';
import pic21 from '../images/pic21.jpg';
import pic22 from '../images/pic22.jpg';
import pic23 from '../images/pic23.jpg';
import pic24 from '../images/pic24.jpg';
import pic25 from '../images/pic25.jpg';
import pic26 from '../images/pic26.jpg';
import pic27 from '../images/pic27.jpg';
import pic28 from '../images/pic28.jpg';
import pic29 from '../images/pic29.jpg';
import pic30 from '../images/pic30.jpg';
import pic31 from '../images/pic31.jpg';
import pic32 from '../images/pic32.jpg';
import pic33_before from '../images/pic33-before.jpg';
import pic33_after from '../images/pic33-after.jpg';
import pic34_before from '../images/pic34-before.jpg';
import pic34_after from '../images/pic34-after.jpg';
import pic35_before from '../images/pic35-before.jpg';
import pic35_after from '../images/pic35-after.jpg';
import pic36_before from '../images/pic36-before.JPG';
import pic36_after from '../images/pic36-after.JPG';
import pic37 from '../images/pic37.jpg';
import pic38 from '../images/pic38.jpg';
import pic39 from '../images/pic39.jpg';
import pic40 from '../images/pic40.jpg';
import pic41 from '../images/pic41.jpg';
import pic42 from '../images/pic42.jpg';
import pic43 from '../images/pic43.jpg';
import pic44 from '../images/pic44.jpg';
import pic45 from '../images/pic45.jpg';
import pic46 from '../images/pic46.jpg';
import pic47 from '../images/pic47.jpg';
import pic48 from '../images/pic48.jpg';
import pic49 from '../images/pic49.JPG';
import pic50 from '../images/pic50.JPG';
import pic51 from '../images/pic51.JPG';
import pic52 from '../images/pic52.JPG';
import pic53 from '../images/pic53.JPG';
import pic54 from '../images/pic54.jpg';
import pic55 from '../images/pic55.jpg';
import pic56 from '../images/pic56.jpg';
import pic57 from '../images/pic57.jpg';
import pic58 from '../images/pic58.jpg';
import pic59 from '../images/pic59.JPG';
import pic60 from '../images/pic60.jpg';
import pic61 from '../images/pic61.JPG';
import pic62 from '../images/pic62.jpg';
import pic63 from '../images/pic63.jpg';
import pic64 from '../images/pic64.jpg';
import pic65 from '../images/pic65.jpg';
import pic66 from '../images/pic66.jpg';
import pic67 from '../images/pic67.jpg';
import pic68 from '../images/pic68.jpg';
import pic69 from '../images/pic69.jpg';
import pic70 from '../images/pic70.jpg';
import pic71 from '../images/pic71.jpg';
import pic72 from '../images/pic72.jpg';
import pic73 from '../images/pic73.jpg';
import pic74 from '../images/pic74.jpg';
import pic75 from '../images/pic75.jpg';
import pic76 from '../images/pic76.jpg';
import pic77 from '../images/pic77.jpg';
import pic78 from '../images/pic78.jpg';
import pic79 from '../images/pic79.jpg';
import pic80 from '../images/pic80.jpg';
import pic81 from '../images/pic81.jpg';
import pic82 from '../images/pic82.jpg';
import pic83 from '../images/pic83.jpg';
import pic84 from '../images/pic84.jpg';
import pic85 from '../images/pic85.jpg';
import pic86 from '../images/pic86.jpg';
import pic87 from '../images/pic87.jpg';
import pic88 from '../images/pic88.jpg';
import pic89 from '../images/pic89.jpg';
import pic90 from '../images/pic90.jpg';
import pic91 from '../images/pic91.jpg';
import pic92 from '../images/pic92.jpg';
import pic93 from '../images/pic93.jpg';
import pic94 from '../images/pic94.jpg';
import pic95 from '../images/pic95.jpg';
import pic96 from '../images/pic96.jpg';
import pic97 from '../images/pic97.jpg';
import pic98 from '../images/pic98.jpg';
import pic99 from '../images/pic99.jpg';
import pic100 from '../images/pic100.jpg';
import pic101 from '../images/pic101.jpg';
import pic102 from '../images/pic102.jpg';
import pic103 from '../images/pic103.jpg';
import pic104 from '../images/pic104.jpg';
import pic105 from '../images/pic105.jpg';
import pic106 from '../images/pic106.jpg';
import pic107 from '../images/pic107.jpg';
import pic108 from '../images/pic108.jpg';
import pic109 from '../images/pic109.jpg';
import pic110 from '../images/pic110.jpg';
import pic111 from '../images/pic111.jpg';
import pic112 from '../images/pic112.jpg';


function Portfolio(props) {
    const [open, setOpen] = useState(false);
    // const [photoPath, setPhotoPath] = useState('');
    const [currentPhotoIndex, setCurrentPhotoIndex] = useState(null);

    const photos = [
                    [pic1, pic5, pic9, pic13],
                    [pic2, pic6, pic10, pic14],
                    [pic3, pic7, pic11_after, pic15],
                    [pic4, pic8, pic12, pic16],

                    [pic17, pic21, pic25, pic29],
                    [pic18, pic22, pic26, pic30],
                    [pic19, pic23, pic27, pic31],
                    [pic20, pic24, pic28, pic32],

                    [pic33_after, pic37, pic41, pic45],
                    [pic34_after, pic38, pic42, pic46],
                    [pic35_after, pic39, pic43, pic47],
                    [pic36_after, pic40, pic44, pic48],

                    [pic49, pic53, pic57, pic61],
                    [pic50, pic54, pic58, pic62],
                    [pic51, pic55, pic59, pic63],
                    [pic52, pic56, pic60, pic64],

                    [pic65, pic69, pic73, pic77],
                    [pic66, pic70, pic74, pic78],
                    [pic67, pic71, pic75, pic79],
                    [pic68, pic72, pic76, pic80],

                    [pic81, pic85, pic89, pic93],
                    [pic82, pic86, pic90, pic94],
                    [pic83, pic87, pic91, pic95],
                    [pic84, pic88, pic92, pic96],

                    [pic97, pic101, pic105, pic109],
                    [pic98, pic102, pic106, pic110],
                    [pic99, pic103, pic107, pic111],
                    [pic100, pic104, pic108, pic112]
                ];

    const photo_scroll = [
        pic1, pic2, pic3, pic4,
        pic5, pic6, pic7, pic8,
        pic9, pic10, pic11_after, pic12,
        pic13, pic14, pic15, pic16,
        pic17, pic18, pic19, pic20,
        pic21, pic22, pic23, pic24,
        pic25, pic26, pic27, pic28,
        pic29, pic30, pic21, pic32,
        pic33_after, pic34_after, pic35_after, pic36_after,
        pic37, pic38, pic39, pic40,
        pic41, pic42, pic43, pic44,
        pic45, pic46, pic47, pic48,
        pic49, pic50, pic51, pic52,
        pic53, pic54, pic55, pic56,
        pic57, pic58, pic59, pic60,
        pic61, pic62, pic63, pic64,
        pic65, pic66, pic67, pic68,
        pic69, pic70, pic71, pic72,
        pic73, pic74, pic75, pic76,
        pic77, pic78, pic79, pic80,
        pic81, pic82, pic83, pic84,
        pic85, pic86, pic87, pic88,
        pic89, pic90, pic91, pic92,
        pic93, pic94, pic95, pic96,
        pic97, pic98, pic99, pic100,
        pic101, pic102, pic103, pic104,
        pic105, pic106, pic107, pic108,
        pic109, pic110, pic111, pic112
    ];            

    useEffect(() => {
        // setPhotoPath(photo_scroll[currentPhotoIndex]);
        if(currentPhotoIndex !== null) setOpen(true);

    }, [currentPhotoIndex]);

    const handleClose = () => {
        setOpen(false);
        setCurrentPhotoIndex(null);    // reset photoIndex
    }

    const handleClick = (photo) => {
        // setOpen(true);
        // setPhotoPath(photo);

        for(let i = 0; i < photo_scroll.length; i++) {
            if(photo === photo_scroll[i]) {
                setCurrentPhotoIndex(i);
                break;
            }
        }
    }

    const incrementPhoto = () => {
        if(currentPhotoIndex < photo_scroll.length - 1) setCurrentPhotoIndex(prevIndex => prevIndex + 1);
        else setCurrentPhotoIndex(0);
    }

    const decrementPhoto = () => {
        if(currentPhotoIndex > 0) setCurrentPhotoIndex(prevIndex => prevIndex - 1);
        else setCurrentPhotoIndex(photo_scroll.length - 1);
    }

    const renderCloseup = () => {
        if(currentPhotoIndex === 32 || currentPhotoIndex === 33 || currentPhotoIndex === 34 || currentPhotoIndex === 35) {
            return (<div></div>);
        }
        else return(<img onClick={() => {handleClose()}} src={photo_scroll[currentPhotoIndex]} alt="Portfolio" />);
    }

    const renderBeforeAfter = () => {
        switch(currentPhotoIndex) {
            case 32:
                return (
                    <div className="before-after" onClick={() => {handleClose()}}>
                        <div className="before">
                            <p>Before</p>
                            <img src={pic33_before} alt="Portfolio" />
                        </div>
                        <div className="after">
                            <p>After</p>
                            <img src={photo_scroll[currentPhotoIndex]} alt="Portfolio" />
                        </div>
                    </div>
                );

            case 33:
                return (
                    <div className="before-after" onClick={() => {handleClose()}}>
                        <div className="before">
                            <p>Before</p>
                            <img src={pic34_before} alt="Portfolio" />
                        </div>
                        <div className="after">
                            <p>After</p>
                            <img src={photo_scroll[currentPhotoIndex]} alt="Portfolio" />
                        </div>
                    </div>
                );

            case 34:
                return (
                    <div className="before-after" onClick={() => {handleClose()}}>
                        <div className="before">
                            <p>Before</p>
                            <img src={pic35_before} alt="Portfolio" />
                        </div>
                        <div className="after">
                            <p>After</p>
                               <img src={photo_scroll[currentPhotoIndex]} alt="Portfolio" />
                        </div>
                    </div>
                );

            case 35:
                return (
                    <div className="before-after" onClick={() => {handleClose()}}>
                        <div className="before">
                            <p>Before</p>
                            <img src={pic36_before} alt="Portfolio" />
                        </div>
                        <div className="after">
                            <p>After</p>
                                <img src={photo_scroll[currentPhotoIndex]} alt="Portfolio" />
                        </div>
                    </div>
                );

            default:
                break;
        }
    }

    return (
        <div className="portfolio background-shapes">
            <Navbar currentComponent={props.currentComponent} setCurrentComponent={props.setCurrentComponent} />
            <h1>Portfolio</h1>
            <div className="photo-container">
                <Grid container>
                    {photos.map((row) => {
                        return (
                            <Grid item align="center" xs={6} sm={3} key={row}>
                                {row.map((photo) => {
                                    return (
                                        <img onClick={() => handleClick(photo)} key={photo} src={photo} alt="Portfolio" />
                                    );
                                })}
                            </Grid>
                        );
                    })}
                </Grid>
            </div>
            <Footer />


            <div className="portfolio-arrows" style={{display: open ? '' : 'none'}}>
                    <svg onClick={() => decrementPhoto()} height="512px" id="Layer_1" fill="white" style={{enableBackground: 'new 0 0 512 512'}} version="1.1" viewBox="0 0 512 512" width="512px"><polygon points="352,115.4 331.3,96 160,256 331.3,416 352,396.7 201.5,256 "/></svg>
                    <svg onClick={() => incrementPhoto()} className="right-arrow" height="512px" id="Layer_1" fill="white" style={{enableBackground: 'new 0 0 512 512'}} version="1.1" viewBox="0 0 512 512" width="512px"><polygon points="352,115.4 331.3,96 160,256 331.3,416 352,396.7 201.5,256 "/></svg>
            </div>
            {renderBeforeAfter()}
            <Dialog className="gallery" open={open} onClose={handleClose}>
                {renderCloseup()}
            </Dialog>
        </div>
    );
}

export default Portfolio;